import React, {useEffect, useState} from 'react'
import _ from "lodash";
import {PRODUCT_COLOR_FILTER_LIST} from "../../../constants/pod.constant";
import SearchBox from "../../../../common/ui/search-box";

const ParentProductColorList = ({parentProduct, setParentProduct}) => {
    const [productColorList, setProductColorList] = useState(parentProduct?.colors);
    const [enableEdit, setEnableEdit] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [selectedColorType, setSelectedColorType] = useState('all');

    const handleDetailChanges = (event, rowIndex, colorDetail) => {
        const {name, value} = event.target;

        const codeValue = (value.indexOf('#') === -1 ? '#' : '') + value;
        colorDetail[name] = _.toUpper(codeValue);

        const tempParentProduct = {...parentProduct};
        const colorIndex = _.findIndex(tempParentProduct.colors, ['name', colorDetail.name])
        tempParentProduct.colors[colorIndex] = colorDetail;
        setParentProduct(tempParentProduct);
    }

    const handleClearSearch = () => {
        setSearchText('');
    }

    useEffect(() => {
        prepareFilteredProductColorList(selectedColorType);
    }, [searchText]);

    const prepareFilteredProductColorList = (colorType?) => {
        let filteredProductColorList = [];

        _.forEach(parentProduct?.colors, colorDetail => {
            if (searchText) {
                if (_.toLower(colorDetail.name).indexOf(_.toLower(searchText)) !== -1) {
                    applySelectedColorTypeFilter(filteredProductColorList, colorDetail, colorType);
                }
            } else {
                applySelectedColorTypeFilter(filteredProductColorList, colorDetail, colorType);
            }

        });

        setProductColorList(filteredProductColorList);
    }

    const applySelectedColorTypeFilter = (filteredProductColorList, colorDetail, colorType) => {
        if (colorType) {
            if (colorType === 'all') {
                filteredProductColorList.push(colorDetail);
            } else if (colorType === 'single' && colorDetail.isSingle) {
                filteredProductColorList.push(colorDetail);
            } else if (colorType === 'multi' && !colorDetail.isSingle) {
                filteredProductColorList.push(colorDetail);
            }
        } else {
            filteredProductColorList.push(colorDetail);
        }
    }

    const handleColorTypeChanges = (event) => {
        const {name, value} = event.target;
        setSelectedColorType(value);
        prepareFilteredProductColorList(value);
    }

    return (
        <>

            <div className="flex justify-between w-fit">

                <div className="flex justify-start flex-wrap">
                    <div className="-ml-2">
                        <SearchBox
                            label={'Search Colors'}
                            searchText={searchText}
                            setSearchText={setSearchText}/>
                    </div>

                    <div className="field-container">
                        <select
                            className="input-field"
                            id="colorType"
                            name="colorType"
                            value={selectedColorType}
                            onChange={handleColorTypeChanges}>
                            {PRODUCT_COLOR_FILTER_LIST?.map((option, index) => (
                                <option key={index}
                                        value={option?.key}>{option?.label}</option>
                            ))}
                        </select>
                    </div>
                </div>


                <div className="float-right">
                    <button
                        onClick={() => setEnableEdit(!enableEdit)}
                        className="button-small mt-2 ml-4 w-48">
                        {!enableEdit && <span>Edit Fields</span>}
                        {enableEdit && <span>Ready Only Fields</span>}
                    </button>
                </div>
            </div>

            <div className="overflow-y-scroll bg-white mt-4">
                <table className="w-full">
                    <thead className="">
                    <tr>
                        <th className="px-2 py-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">
                            Color
                        </th>
                        <th className="px-2 py-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">
                            Color Code
                        </th>
                    </tr>
                    </thead>
                    <tbody className="">
                    {productColorList?.map((productColor, rowIndex) => (
                        <tr key={`row-${rowIndex}`} className="border border-gray-400">
                            <td className="p-2 border border-gray-400 m-auto">
                                <div>{productColor?.name}</div>
                            </td>

                            <td className={`p-2 border border-gray-400 w-1/2 ${enableEdit ? 'bg-gray-200' : ''}`}>
                                {!enableEdit &&
                                    <div>{productColor?.code}</div>
                                }

                                {enableEdit &&
                                    <>
                                        <input
                                            type="text"
                                            className="input-field w-full"
                                            id="code"
                                            name="code"
                                            value={productColor?.code || ''}
                                            onChange={(event) => {
                                                handleDetailChanges(event, rowIndex, productColor);
                                            }}>
                                        </input>
                                    </>
                                }
                            </td>

                        </tr>

                    ))}
                    </tbody>
                </table>
            </div>

        </>
    )
}

export default ParentProductColorList
